import React from "react";

export const Contact = () => {
  return <div><h1>contact!</h1></div>;
};
